import styled from 'styled-components'

type Props = {
  title: string
  src: string
}

export const Video = ({ title, src }: Props) => {
  return (
    <Iframe
      title={title}
      src={src}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  )
}

const Iframe = styled.iframe`
  height: 202px;
  width: 316px;

  @media screen and (max-width: 1047px) {
    width: 350px;
    height: 224px;
  }
`
